{
  "background.pilot": "Militärpilot",
  "background.naval_officer": "Marineoffizier",
  "background.marine_biologist": "Meeresbiologie",
  "background.pilot.blurb": "Zweihundert Flugstunden über diesem Wasser. Bei einer davon kam nur eine Maschine zurück.",
  "background.naval_officer.blurb": "Vierzehn Jahre auf See, zuletzt als Wachoffizier. Sie haben das Kommando abgegeben, nicht verloren.",
  "background.marine_biologist.blurb": "Sie kennen dieses Meer aus Messreihen und aus zweiter Hand. Beides hat Sie hierher gebracht.",
  "background.pilot.effect": "Bei Flugzeugvorfällen ist Ihre Einschätzung deutlich sicherer.",
  "background.naval_officer.effect": "Sie fahren schwere See ab — der Rumpf leidet spürbar weniger.",
  "background.marine_biologist.effect": "Sie lesen die Umgebung: Kalte Spuren geben einen Hinweis mehr her.",
  "background.lost.wingman": "Ihr Rottenflieger",
  "background.lost.crew": "Ihr Bootsmann",
  "background.lost.parents": "Ihre Mutter",
  "character.title": "Wer sind Sie?",
  "character.name": "Name",
  "character.name.reroll": "Anderer Name",
  "character.background": "Herkunft",
  "character.lost": "Verloren: {name} — {relation}",
  "character.begin": "Anfangen",
  "character.randomise": "Auswürfeln",
  "menu.new": "Neues Spiel",
  "menu.continue": "Fortsetzen",
  "menu.seed": "Seed",
  "menu.seed.random": "Neu würfeln",
  "menu.language": "Sprache",
  "menu.subtitle": "Ein Fall, der jedes Mal anders ausgeht.",
  "finale.crew.doubt": "{name} widerspricht: „Das trägt nicht. Nicht mit dem, was wir gesehen haben.“",
  "finale.crew.agree": "{name} nickt langsam. „Das würde alles erklären.“",
  "finale.tally": "Bilanz: {rescued} gerettet, {lost} nicht.",
  "finale.personal.found": "Und {name}? Auch das steht jetzt fest. Es hilft nicht so, wie Sie gehofft hatten.",
  "finale.personal.open": "Über {name} sagt keiner der Funde etwas. Manche Fragen bleiben offen.",
  "finale.close": "Bericht schließen",
  "clue.visitors.personal_trace": "In der Liste der Namen steht auch {name}. Das Datum daneben liegt in der Zukunft.",
  "clue.leviathan.personal_trace": "Aus dem Mageninhalt eines gestrandeten Kadavers wird eine Erkennungsmarke geborgen. Sie gehört {name}.",
  "clue.meridian.personal_trace": "In den Unterlagen taucht {name} auf — nicht als Vermisste, sondern als Posten. Abgerechnet und abgeschlossen.",
  "clue.descendants.personal_trace": "Auf der Metallplakette steht {name}, mit einem Sterbedatum, das noch nicht eingetreten ist.",
  "clue.rift.personal_trace": "Auf dem Funkband ist die Stimme von {name}. Die Aufnahme ist von heute Morgen.",
  "crew.first_officer": "Erster Offizier Halloran",
  "clue.cartographers.personal_trace": "In der Reihe der Umrisse steht einer an vierter Stelle, dessen Maße auf {name} passen. Er ist nicht beschädigt. Er ist nur nicht mehr da, wo er hingehört.",
  "clue.wreckers.personal_trace": "In den Papieren einer Reederei steht {name}. Angeheuert, drei Monate nach dem Verschwinden, auf einem Schiff, das es unter diesem Namen nicht gibt.",
  "clue.echo.personal_trace": "Ein Funkspruch, aufgezeichnet vor drei Wochen, in dem {name} eine Position durchgibt. Aufgenommen wurde er sechs Tage nach dem Verschwinden."
}
